import { Context } from "@nuxt/types";
import { functions } from "~/setups/firebase";
import { verifyReceptionAccessViaCallable } from "~/utils/receptionToken";

/**
 * Allow the reception page when the user is logged in, or when a valid opaque
 * reception token (e.g. from email) is present.
 * Token verification is server-side via verifyReceptionAccess CF.
 * Check-in writes go through checkInWithReceptionToken CF.
 */
export default async function ({ store, redirect, route, app }: Context) {
  const appointmentId = route.query.appointmentId;
  const token = route.query.token;

  // Prefer opaque token when present (works even if another account is logged in).
  if (typeof appointmentId === "string" && typeof token === "string") {
    try {
      const callable = functions.httpsCallable("verifyReceptionAccess");
      const valid = await verifyReceptionAccessViaCallable(
        callable as any,
        appointmentId,
        token
      );
      if (valid) return;
    } catch (error) {
      console.error("Failed to verify reception access token:", error);
    }
  }

  if (store.getters["auth/isLoggedIn"]) {
    return;
  }

  redirect(app.localePath("/appointment/signup"), { from: route.fullPath });
}
